import { useSelector } from 'react-redux'

import {
  selectEconomySets,
  selectEconomySetsData,
  selectEconomySetsFetched,
  selectShouldFetch
} from 'redux/selectors/EconomySets'

/**
 * Hook for all economy sets
 * @returns [economy sets, loading]
 */
export const useEconomySets = () => {
  return useSelector(selectEconomySets)
}

/**
 * Hook to check if economy sets should be fetched.
 * @returns boolean
 */
export const useShouldFetchEconomySets = () => {
  return useSelector(selectShouldFetch)
}

/**
 * Hook for economy sets keyed by id
 * @returns economy set body
 */
export const useEconomySetsData = () => {
  return useSelector(selectEconomySetsData)
}

/**
 * Hook to check if economy sets are fetched.
 * @returns boolean
 */
export const useEconomySetsFetched = () => {
  return useSelector(selectEconomySetsFetched)
}
